import React from 'react';

export const HerancasCallout = () => (
  <section className="valuare-herancas-section" id="herancas" data-testid="herancas-callout">
    <div className="valuare-herancas-inner">
      <div className="valuare-herancas-left">
        <div className="valuare-herancas-label">Regime Jurídico</div>
        <h2 className="valuare-herancas-title">Lei das Heranças Indivisas</h2>
      </div>
      <div className="valuare-herancas-content">
        <p>
          A Lei n.º 49/2026, de 17 de agosto, autoriza o Governo a criar um processo especial de venda de imóveis integrados em herança indivisa, que qualquer herdeiro poderá requerer sem o consentimento dos restantes, decorridos dois anos sobre a abertura da sucessão. A lei de autorização prevê que o valor de venda seja fixado com base em avaliações periciais juntas ao processo. O regime ainda não está em vigor, dependendo do decreto-lei que o concretize.
        </p>
        <div className="valuare-herancas-highlight">
          Acompanhamos a evolução do diploma e atualizamos esta informação quando o decreto-lei for publicado.
        </div>
      </div>
    </div>
  </section>
);
